import HeroSlider, { Overlay, Slide, MenuNav } from "hero-slider";
import Wrapper from "./Wrapper";
import Title from "./Title";
import Subtitle from "./Subtitle";

import bogliasco from '../assets/imgs/hero1.jpg';
import countyClare from '../assets/imgs/hero3.jpg';
import craterRock from '../assets/imgs/hero4.jpg';
import giauPass from '../assets/imgs/hero2.jpg';
import { Link } from 'react-router-dom';


export default function MainHeader() {
    return (
        <HeroSlider
          height={"100vh"}
          autoplay
          controller={{
            initialSlide: 1,
            slidingDuration: 500,
            slidingDelay: 100,
            onSliding: (nextSlide) =>
              console.debug("onSliding(nextSlide): ", nextSlide),
            onBeforeSliding: (previousSlide, nextSlide) =>
              console.debug(
                "onBeforeSliding(previousSlide, nextSlide): ",
                previousSlide,
                nextSlide
              ),
            onAfterSliding: (nextSlide) =>
              console.debug("onAfterSliding(nextSlide): ", nextSlide)
          }}
        >
          <Overlay>
            <Wrapper>
              <Title> <span className="text-white">James Kalu</span></Title>
              <Subtitle> <span className="text-white">
              Senior UI/UX Designer & Frontend Developer <br/> <br/>
              Crafting Scalable Digital Experiences </span>
              <br/> <br/> <br/>
              <div className="">
                <Link to="/resume" className="btn btn-default btn-send" rel="noopener noreferrer">
        <i class="bi bi-printer me-2"></i>Print Resume
              </Link>
                </div>
              </Subtitle>
            </Wrapper>
          </Overlay>
    
          <Slide
            //shouldRenderMask
            label="Web & Mobile App Design"
            background={{
              backgroundImageSrc: giauPass,
              backgroundAttachment: "fixed"
            }}
          />
    
          <Slide
            //shouldRenderMask
            label="Branding & Identity Design"
            background={{
              backgroundImageSrc: bogliasco,
              shouldLazyLoad: false,
              backgroundAttachment: "fixed"
            }}
          />
    
          <Slide
            //shouldRenderMask
            label="Frontend Development"
            background={{
              backgroundImageSrc: countyClare,
              backgroundAttachment: "fixed"
            }}
          />
    
          <Slide
            //shouldRenderMask
            label="Manual & Automation Testing"
            background={{
              backgroundImageSrc: craterRock,
              backgroundAttachment: "fixed"
            }}
          />
    
          <MenuNav />
        </HeroSlider>
  );
}
